<template>
  <div class="only-labels--content no-select">
    <div v-if="!labels.length" class="alert alert-sm alert-info mrg-t-10">
      Записи не найдены
    </div>
    <div class="labels">
      <div class="items" v-for="(item, index) in labels" :key="index">
        <div
            @click="emitEnroll(item)"
            class="enroll item"
            v-bind:class="{
              new: item.confirm == 0,
              confirm: item.confirm == 1,
              done: item.confirm == 2,
              canceled: item.confirm == 3,
            }"
        >
          <div class="head">
            <div class="text">
              {{dateToString(item.date)}} - {{ minuteToTime(item.time) }}
            </div>
          </div>
          <div class="more">
            <div v-if="+item.is_group === 1" class="client_name">
              <span class="text-bold">{{ calculateActiveGroupCount(item.enrollClients) }}</span> клиента (-ов) в групповой записи
            </div>
            <div v-if="+item.is_group === 0" class="client_name">
              <b>Клиент:</b> 
              <span>
                {{ item.enrollClients[0].clients.name }} {{ item.enrollClients[0].clients.surname }}
              </span>
              <span v-if="item.enrollClients[0].clientModification">
                ({{ item.enrollClients[0].clientModification.name }})
              </span>
            </div>

            <div class="staff_name">
              <b>Сотрудник:</b> {{ item.staff.name }}
            </div>
            <div class="client_services">
                <b>Услуга(-и):</b> <span v-for="service in item.enrollPosition" :key="service.id"
                >{{ service.service_name }};
                </span>
            </div>
            <div class="client_price">
              <b>Стоимость:</b> {{computedPrice(item.enrollPosition)}}
            </div>
            <div v-if="+item.is_group === 0" class="client_comment">
              <b>Комментарий клиента:</b> {{item.enrollClients[0].comment?item.enrollClients[0].comment:'-'}}
            </div>
            <div class="company_comment">
              <b>Ваш комментарий:</b> {{item.comments?item.comments.comment_company:'-'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Formatter from "@/components/libraries/Formatter";

const formatter = new Formatter();

export default {
  name: "OnlyLabels",
  components: {},
  data() {
    return {
      labels: []
    };
  },
  props: {
    data: Array,
    showClient: Boolean, // показывать данные клиента или нет
    showModification: Boolean, // показывать модификацию клиента
    modificationsList: Array, // список модификаций
  },
  watch: {
    data: function(val){
      this.labels = val;
    }
  },
  computed: {
    modificationListByKey(){
      let result = [];
      if(this.modificationsList){
        for(let key in this.modificationsList){
          result[this.modificationsList[key].id] = this.modificationsList[key].name;
        }
      }
      return result;
    }
  },
  methods: {
    calculateActiveGroupCount(data){
      let result = 0;
      for(let key in data){
        if(+data[key].is_canceled === 0){
            if(data[key].clients){
              result++;
            }
          }
      }
      return result;
    },
    computedPrice(enrollPosition){
      let price = 0;
      for(let key in enrollPosition){
        price += +enrollPosition[key].price;
      }
      return price;
    },
    minuteToTime(minutes) {
      return formatter.minuteToTime(minutes);
    },
    datePhpToRus(date){
      return formatter.phpDateToRus(date);
    },
    dateToString(date){
      return formatter.phpDateToShortString(date);
    },
    emitEnroll(item){
      this.$emit('selectEnroll', item);
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.items {
  .item {
    border-radius: 6px;
    margin-top: 20px;
    /*box-sizing: border-box;*/
    font-size: 14px;
    cursor: pointer;

    &.new {
      background-color: #ff3d3d;
    }
    &.confirm {
      background-color: #fecf63;
    }
    &.done {
      background-color: #36deac;
    }
    &.canceled {
      background-color: #9946e7;
    }
    &.free {
      background-color: #f0f4f9;
    }
    &.progress {
      box-shadow: 0 0 0 rgba(204, 169, 44, 0.4);
      animation: pulse 1s infinite;
    }

    .head {
      border-radius: 6px;
      position: relative;
      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.25);

      .action {
        width: 30px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;

        & > div {
          position: absolute;
          top: 8px;
        }
      }
      .text {
        font-size: 14px;
        color: #4f4f4f;
        text-align: center;
        font-weight: 500;
        padding: 10px 0;

        .duration_window {
          font-size: 10px;
        }
      }
    }

    .more {
      color: #333333;
      font-size: 13px;
      padding: 8px 5px 8px 15px;
      box-sizing: border-box;

      .client_services {
        white-space: nowrap; /* Запрещаем перенос строк */
        overflow: hidden; /* Обрезаем все, что не помещается в область */
        text-overflow: ellipsis; /* Добавляем многоточие */
      }
    }
  }
}
</style>
